import React, { useEffect, useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { FaDownload } from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";

const Gallery = () => {
  const [images, setImages] = useState([]);

  useEffect(() => {
    fetch("/imagesNames.json")
      .then((res) => res.json())
      .then((data) => setImages(data));
  }, []);

  return (
    <div style={{ padding: "20px", background: "#111", minHeight: "100vh" }}>
      <h2 style={{ textAlign: "center", color: "#fff", marginBottom: "30px" }}>
        Total Images: {images.length}
      </h2>
      <div style={styles.grid}>
        {images.map((name, index) => (
          <div key={index} style={styles.card}>
            <LazyLoadImage
              src={`/images/${name}`}
              alt={name}
              effect="blur"
              style={styles.image}
            />
            <a
              href={`/images/${name}`}
              download={name}
              style={styles.downloadIcon}
              title="Download"
            >
              <FaDownload />
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

const styles = {
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(180px, 1fr))",
    gap: "15px",
    justifyItems: "center",
  },
  card: {
    position: "relative",
    width: "180px",
    // height: "270px", // fixed row-like size
    background: "#222",
    borderRadius: "10px",
    overflow: "hidden",
    boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "contain", // keeps original aspect ratio, fits in card
    display: "block",
    transition: "transform 0.3s",
  },
  downloadIcon: {
    position: "absolute",
    top: "10px",
    right: "10px",
    background: "rgba(0,0,0,0.6)",
    borderRadius: "50%",
    padding: "6px",
    color: "#fff",
    textDecoration: "none",
    zIndex: 2,
  },
};

export default Gallery;
